<ng-container *ngIf="(image$ === null) || (image$ | async) as image; else showIcon;">
	<img obgImageContentGroup="common" *ngIf="image$ !== null" [src]="image.url" [alt]="image.altText" />
</ng-container>
<ng-template #showIcon>
	<span class="ico-check-mark-circle-o"></span>
</ng-template>
<p>{{ keys?.titleKey | translate }}</p>

<ol *ngIf="jurisdiction !== ksaJurisdiction || withRewards || variant === 'created'">
	<li class="open-account">{{ 'customer-verification.open-account' | translate }}</li>
	<li class="bonus-deposit">{{ keys?.listItemKey | translate }}</li>
	<li class="play">{{ 'customer-verification.play-and-have-fun' | translate }}</li>
</ol>

<button
	mat-flat-button
	color="accent"
	(click)="navigateToAction()"
	test-id="customer-verification-action-button"
	data-test-id="customer-verification-action-button"
>
	{{ keys?.buttonKey | translate }}
</button>

<div class="obg-m-deposit-without-bonus" *ngIf="!showDepositButtonOnly">
	<button
		mat-stroked-button
		color="accent"
		*ngIf="withRewards"
		(click)="navigateToDeposit()"
		test-id="customer-verification-deposit-button"
	>
		{{ 'customer-verification.button-deposit-without-bonus' | translate }}
	</button>
	<a (click)="dismiss()" test-id="customer-verification-site-link"
		>{{ 'customer-verification.button-enter-site' | translate }}</a
	>
</div>

<mat-card *ngIf="jurisdiction === mgaJurisdiction">
	<mat-card-title>
		<mat-icon class="ico-deposit-limit-shield"></mat-icon>
		<span class="rg-info-notice-title">{{ 'responsible-gaming.welcome-notice-title' | translate }}</span>
	</mat-card-title>
	<mat-card-content [innerHtml]="'responsible-gaming.welcome-notice-message' | translate"></mat-card-content>
</mat-card>
